import { ILogListItem, LogListItem } from "./logListItem";
import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";

export interface ILogListItems extends IListItems<ILogListItem> {}

export class LogListItems extends ListItems<LogListItem> implements ILogListItems {
    constructor();
    constructor(obj: ILogListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, LogListItem);
    }
}